// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_2F0Fl","title":"_3kF36","iconContainer":"_18aFN","icon":"_2jvNT"};